<div class="card">
    <div class="card-header" style="border-bottom: none">
      <div class="card-title d-flex flex-column align-items-center">
        <h4 style="margin: 0">{{ data.title }}</h4>
      </div>
    </div>
  
  
    <div class="card-body">
      <!-- Top-right note (above the chart) -->
      <div *ngIf="!hasError" class="note note-top-right">
        <strong>Note:</strong>
        This page provides an overview of total spend and project count across different cost intervals for a PHI Parameter.
        Clicking on a bubble displays a project-level breakdown.
      </div>
  
      <!-- Chart area -->
      <div class="chart-wrap" [hidden]="hasError">
        <div [id]="data.widgetId" class="chart"></div>
        <!-- <small class="legend-inline">
          <i>⚫ Size of the bubble indicates the no. of projects within that spend bracket</i>
        </small> -->
      </div>
  
      <!-- Bottom-left note (below the chart) -->
      <div *ngIf="!hasError" class="note note-bottom-left">
        <strong>Notes:</strong>
        <ul>
          <li>This screen gives an overview of how are we working on different PHI parameters and how much are we spending on those efforts</li>
          <li>Size of the bubble indicates the no. of projects within that spend bracket and across PHI parameters</li>
          <li>Click on the bubble to show details of projects associated to the bubble</li>
          <li>The color of the PHI parameter denotes the PHI performance for last quarter, whose legend is as below. (requires selection of 1 specific platform and 1 specific segment)</li>
          <span style="color:red">Red</span> – Score between 1–3; <span style="color:orange">Yellow</span> – Score between 4–7; <span style="color:green">Green</span> – Score between 8–10
        </ul>
      </div>
      <app-data-error *ngIf="hasError" [message]="errorMessage"></app-data-error>
    </div>
  </div>
  